import { QueryClient } from "@tanstack/react-query";

// The single TanStack Query client (Front-End.md). Exported as a module singleton so non-component
// code — the org store (purge-on-switch) and logout — can reach it without prop/context plumbing.
// Settings carried from v2.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});
